import { render } from "./Xing.vue?vue&type=template&id=6b363ede"
import script from "./Xing.vue?vue&type=script&lang=js"
export * from "./Xing.vue?vue&type=script&lang=js"
script.render = render

export default script